import { Button, SettingsCard, SettingsCardRow } from 'design-system';
import { Plus } from 'lucide-react';

import { Permission } from '@/entities/permissions';
import UpgradeToPremiumButton from '@/features/_shared/UpgradeToPremium/UpgradeToPremiumButton';
import { usePermission } from '@/features/_shared/user';
import {
  ExpiredBannerType,
  useExpiredBannerContent
} from '@/features/profile/hooks/useExpiredBannerContent';
import KeyDialog from '@/features/profile/KeyDialog';

import ApiKeyTable from './Table';
import useTokenGeneration from './useTokenGeneration';

const TokenGenerationComponent = () => {
  const { hasPermission } = usePermission();
  const hasGenerateTokenPermission = hasPermission(Permission.GenerateApiToken);
  const expiredBannerContent = useExpiredBannerContent();
  const { apiKeys, open, setOpen, error } = useTokenGeneration(hasGenerateTokenPermission);

  const upgradeButtonType =
    expiredBannerContent?.type === ExpiredBannerType.expired ||
    expiredBannerContent?.type === ExpiredBannerType.trialEndingSoon
      ? 'expired'
      : 'upgrade';

  return (
    <SettingsCard
      title='API Tokens'
      action={
        <Button
          disabled={!hasGenerateTokenPermission}
          size='sm'
          onClick={() => {
            setOpen(!open);
          }}
        >
          <Plus aria-hidden='true' />
          Generate new token
        </Button>
      }
    >
      <KeyDialog
        open={open}
        setOpen={setOpen}
      />
      {!hasGenerateTokenPermission ? (
        <SettingsCardRow label='Access'>
          <div className='flex flex-col items-start gap-4'>
            <p>GX Go Premium users can export data through our API and many other methods.</p>
            <UpgradeToPremiumButton type={upgradeButtonType} />
          </div>
        </SettingsCardRow>
      ) : (
        <SettingsCardRow>
          {error || (
            <ApiKeyTable
              apiKeys={apiKeys}
              onGenerateToken={() => setOpen(true)}
            />
          )}
        </SettingsCardRow>
      )}
    </SettingsCard>
  );
};

export default TokenGenerationComponent;
